import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import {Store} from "@ngxs/store";
import {Observable} from "rxjs";
import {GetUserProfileAction} from '../actions/user-profile.actions';

@Injectable({ providedIn: 'root' })
export class UserProfileResolver  {
  constructor(private store: Store) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.store.dispatch(new GetUserProfileAction())
  }
}
